var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwingate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3545 21.5348V32.3295C17.3545 32.4102 17.4452 32.4576 17.5115 32.4116L20.5472 30.3057C20.5741 30.287 20.5902 30.2563 20.5902 30.2235V23.7026C20.5902 22.4376 21.1885 21.2473 22.2036 20.4925L26.7002 17.1494C26.7256 17.1305 26.7405 17.1008 26.7405 17.0692V12.6138C26.7405 12.5311 26.6458 12.4841 26.58 12.5342L18.9328 18.3512C17.9383 19.1077 17.3545 20.2854 17.3545 21.5348Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0479 24.8512V35.6448C22.0479 35.7257 22.139 35.7731 22.2052 35.7267L29.7294 30.4541C30.7977 29.7055 31.4339 28.4829 31.4339 27.1784V15.9302C31.4339 15.8475 31.3392 15.8006 31.2733 15.8506L23.6262 21.6676C22.6317 22.4241 22.0479 23.6018 22.0479 24.8512Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwingate);
export default __webpack_public_path__ + "static/media/Twingate.0f7f5c375aa8eb2687ee5d38e63d921f.svg";
export { ForwardRef as ReactComponent };